import type { TranslationSchema } from '../zh';

const login: TranslationSchema['login'] = {
  brand_product: 'Kết nối KOL',
  brand_tagline: 'Nền tảng chuyên nghiệp kết nối và quản lý marketing KOL TikTok',
  hero_welcome: 'Chào mừng đến với Wowbit.ai',
  hero_desc:
    'Đăng nhập bằng số điện thoại hoặc email. Ủy quyền cửa hàng chính thức (Đông Nam Á) · Tin nhắn / Email nền tảng / Lời mời định hướng.',
  plan_pro: 'Chuyên nghiệp',
  hero_feature:
    'Kho KOL TikTok khổng lồ, lọc chính xác mục tiêu, hỗ trợ mời tin nhắn hàng loạt, mời email và gợi ý sản phẩm định hướng—một quy trình từ khám phá, tiếp cận đến quản lý hợp tác, ',
  hero_feature_highlight: 'giúp kết nối KOL chính xác hơn và hợp tác marketing hiệu quả hơn.',

  title: 'Chào mừng đến với Wowbit.ai',
  subtitle: 'Đăng nhập để bắt đầu kết nối KOL',
  register_title: 'Đăng ký Wowbit.ai',
  register_subtitle: 'Điền thông tin để hoàn tất đăng ký và bắt đầu kết nối KOL',
  wechat_login: 'Đăng nhập WeChat',
  wechat_qr_title: 'Đăng nhập WeChat',
  wechat_scan: 'Quét mã WeChat để đăng nhập',
  wechat_qr_failed: 'Không tạo được mã QR',
  wechat_expired: 'Mã QR đã hết hạn, vui lòng tạo lại',
  wechat_refresh: 'Tạo lại',
  wechat_expires_in: 'Hết hạn sau {{time}}',
  or: 'hoặc',
  login_method: 'Phương thức đăng nhập',
  code_login: 'Mã xác minh',
  password_login: 'Mật khẩu',

  account_label: 'Số điện thoại / Email',
  account_placeholder: 'Nhập số điện thoại hoặc email',
  account_required: 'Vui lòng nhập số điện thoại hoặc email',
  account_invalid: 'Vui lòng nhập số điện thoại hoặc email hợp lệ',
  username_label: 'Tên người dùng',
  username_placeholder: 'Nhập tên người dùng',
  username_required: 'Vui lòng nhập tên người dùng',
  username_max: 'Tên người dùng tối đa 12 ký tự',
  display_name_max: 'Tên hiển thị tối đa 128 ký tự',
  code_label: 'Mã xác minh',
  code_placeholder: 'Mã 6 chữ số',
  code_required: 'Vui lòng nhập mã xác minh',
  code_len: 'Mã xác minh gồm 6 chữ số',
  code_digits: 'Mã xác minh gồm 6 chữ số',
  send_code: 'Lấy mã',
  password_label: 'Mật khẩu',
  password_placeholder: 'Nhập mật khẩu',
  password_required: 'Vui lòng nhập mật khẩu',
  password_min: 'Mật khẩu tối thiểu 6 ký tự',
  password_rule: 'Mật khẩu tối thiểu 12 ký tự và không quá 72 byte UTF-8',
  login_password_rule: 'Mật khẩu không quá 72 ký tự và 72 byte UTF-8',

  login_btn: 'Đăng nhập',
  register_btn: 'Đăng ký',
  forgot_password: 'Quên mật khẩu?',
  go_register: 'Đăng ký ngay',
  go_login: 'Đã có tài khoản? Đăng nhập',

  reset_password_title: 'Đặt lại mật khẩu',
  new_password_label: 'Mật khẩu mới',
  new_password_required: 'Vui lòng nhập mật khẩu mới',
  confirm_password_label: 'Xác nhận mật khẩu mới',
  confirm_password_required: 'Vui lòng nhập lại mật khẩu mới',
  password_mismatch: 'Hai mật khẩu không khớp',
  reset_password_rule:
    'Tối thiểu 12 ký tự, không chứa khoảng trắng và không quá 72 byte UTF-8',
  reset_password_btn: 'Đặt lại mật khẩu',
  reset_password_success: 'Đặt lại mật khẩu thành công, vui lòng đăng nhập bằng mật khẩu mới',
  reset_password_failed: 'Đặt lại thất bại',
  reset_password_failed_retry: 'Đặt lại thất bại, vui lòng thử lại sau',

  code_sent: 'Đã gửi mã xác minh',
  send_failed: 'Gửi thất bại',
  send_failed_retry: 'Gửi thất bại, vui lòng thử lại sau',
  login_success: 'Đăng nhập thành công',
  login_failed: 'Đăng nhập thất bại',
  login_failed_retry: 'Đăng nhập thất bại, vui lòng thử lại sau',
  register_success: 'Đăng ký thành công, vui lòng đăng nhập',
  register_failed: 'Đăng ký thất bại',
  register_failed_retry: 'Đăng ký thất bại, vui lòng thử lại sau'
};

export default login;
